import { GetTables_Venue_floorPlans_tables as TableType } from '~Scenes/Venue/__queries__';

export enum TableKey {
  your_tables = 'your_tables',
  recent = 'recent',
  floor_plan = 'floor_plan',
  all_tables = 'all_tables',
}

export type TableComponentProps = {
  table: TableType;
  keyType: TableKey;
  isMapView?: boolean;
};

// Sorts tables by their code; 1, 2, 3 etc, codes including letters will end up last
export function sortTablesByCode(tablesArray: TableType[]) {
  return [...tablesArray].sort((a: TableType, b: TableType) => {
    return a.code.localeCompare(b.code, undefined, {
      numeric: true,
    });
  });
}
